import React from "react";
import VideoModuleDetail from "../../components/VideoModule/VideoModuleDetail";

const ExpertOpinionDetail = () => (
  <VideoModuleDetail moduleCode="expert_opinion" routeBase="/expert_opinion" />
);

export default ExpertOpinionDetail;
